import { SVGProps } from 'react';

export const EmptyInboxIcon = (props: SVGProps<any>) => (
  <svg
    width="131"
    height="97"
    viewBox="0 0 131 97"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M125.418 92C129.007 83.8979 131 74.9317 131 65.5C131 29.3253 101.675 0 65.5 0C29.3253 0 0 29.3253 0 65.5C0 74.9317 1.9935 83.8979 5.58215 92H125.418Z"
      fill="url(#paint0_linear_2272_119314)"
    />
    <g filter="url(#filter0_dd_2272_119314)">
      <path
        d="M34.5371 48.0842C34.5371 46.0722 35.5455 44.1942 37.2226 43.0828L59.8228 28.1055C61.7619 26.8205 64.2689 26.7721 66.2561 27.9813L91.1185 43.1094C92.9076 44.198 93.9996 46.1408 93.9996 48.2351V75.1578C93.9996 78.4715 91.3133 81.1578 87.9996 81.1578H40.5371C37.2234 81.1578 34.5371 78.4715 34.5371 75.1578V48.0842Z"
        fill="white"
      />
      <path
        d="M37.0017 42.7493C35.2128 43.9349 34.1371 45.9381 34.1371 48.0842V75.1578C34.1371 78.6924 37.0025 81.5578 40.5371 81.5578H87.9996C91.5342 81.5578 94.3996 78.6924 94.3996 75.1578V48.2351C94.3996 46.0012 93.2348 43.9289 91.3264 42.7677L66.4641 27.6396C64.3444 26.3498 61.6702 26.4014 59.6018 27.7721L37.0017 42.7493Z"
        stroke="#E5E7EB"
        strokeWidth="0.8"
      />
    </g>
    <path d="M36 43.5L44 38.5L82.5 37.5L92 43.5L63 65.5L36 43.5Z" fill="#E3E6E9" />
    <rect
      x="85.3225"
      y="18.6702"
      width="47.8893"
      height="42.6427"
      rx="6.4"
      transform="rotate(90.0953 85.3225 18.6702)"
      fill="#F7F8F8"
      stroke="#D1D5DB"
      strokeWidth="0.8"
      strokeDasharray="2 2"
    />
    <path d="M64 65.5L36 45L39 75L86.5 75.5L91 53L92 44L64 65.5Z" fill="white" />
    <path
      d="M68.4883 42.7129C68.4883 42.7129 65.1 39.3246 60.2596 42.7129"
      stroke="#4B5563"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <circle cx="54.9362" cy="36.0673" r="1.93617" fill="#4B5563" />
    <circle cx="73.3288" cy="36.0673" r="1.93617" fill="#4B5563" />
    <path d="M92 43.5L64 65.5L36 44" stroke="#E5E7EB" strokeWidth="0.8" />
    <path d="M61.5 62.5L53.5 68L50.5 70H77L66 62.5H61.5Z" fill="white" />
    <path
      d="M92 80L67.2076 63.1766C65.2552 61.8517 62.7076 61.7942 60.6973 63.0294L35 78.8201"
      stroke="#E5E7EB"
      strokeWidth="0.8"
    />
    <circle cx="94" cy="84" r="9" fill="url(#paint1_linear_2272_119314)" />
    <path
      d="M96.8299 81.1699L91.1699 86.8299"
      stroke="#9CA3AF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M96.8299 86.8299L91.1699 81.1699"
      stroke="#9CA3AF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M94 93V93C89.029 93 85 88.971 85 84V84C85 79.029 89.029 75 94 75V75C98.971 75 103 79.029 103 84V84C103 88.971 98.971 93 94 93Z"
      stroke="#9CA3AF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_dd_2272_119314"
        x="26.3373"
        y="22.6069"
        width="75.8625"
        height="73.7509"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="2.35" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.966439 0 0 0 0 0.966439 0 0 0 0 0.966439 0 0 0 1 0"
        />
        <feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow_2272_119314" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="7" />
        <feGaussianBlur stdDeviation="3.7" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.964706 0 0 0 0 0.964706 0 0 0 0 0.964706 0 0 0 0.5 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_2272_119314"
          result="effect2_dropShadow_2272_119314"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_2272_119314"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2272_119314"
        x1="68"
        y1="-67.5"
        x2="69.9323"
        y2="144.789"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.4" stopColor="#EFEFEF" />
        <stop offset="0.714773" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2272_119314"
        x1="91"
        y1="76"
        x2="94"
        y2="93"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.249877" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.2" />
      </linearGradient>
    </defs>
  </svg>
);
